import InlineLoading from './inline-loading';

export default InlineLoading;
